import { oc } from '@orpc/contract';
import { createRunDraftInputSchema, runDetailSchema } from '../schemas/runs.schemas.js';
export const createRunDraftContract = oc
    .route({
    method: 'POST',
    path: '/runs',
    tags: ['Runs'],
    summary: 'Start a draft test run',
    description: 'The scenario decides whether a route is required: an IDLE run has none, a DRIVE run needs one of the scenario’s route type.',
})
    .input(createRunDraftInputSchema)
    .output(runDetailSchema);
//# sourceMappingURL=create-run-draft.contract.js.map